import React, {SetStateAction, SyntheticEvent, useContext, useEffect, useRef, useState} from "react";
import './OffersView.css'
import {Api} from "../../RequestsProvider/RequestProvider";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
import CButton from "../../Components/Button/CButton";
import {
    ArrowRight,
    BalloonHeartFill, ExclamationDiamond,
    Search, Trash,
    XLg
} from "react-bootstrap-icons";
import {BarLoader} from "react-spinners";
import TableRow from "../../Components/TableRow/TableRow";
import {Context} from "../../ContextProvider/Context";
import Modal from "../../Components/Modal/Modal";
import product from "../../assets/images/fresh-produce.png";
import {toast} from "react-toastify";

export interface ProductNotification {
    id: number;
    apiKeyID: number;
    createdAt: Date;
    productName: string;
    activeNotification: boolean | string;
}
export const OffersView = () => {

    const [productNotifications, setProductNotifications] = useState<ProductNotification[]>([])
    const [productNotificationsToDelete, setProductNotificationsToDelete] = useState<ProductNotification>()
    const [tableIsLoading, setTableIsLoading] = useState(false)
    const [productFilter, setProductFilter] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [showAddProductModal, setShowAddProductModal] = useState(false)
    const addProductNameRef = useRef<HTMLInputElement>(null)
    const [errorMessage, setErrorMessage] = useState("")

    const request = useContext(Api)
    const context = useContext(Context)
    const {getAllProductNotifications, deleteProductNotifications, addProductNotifications} = request!
    const {setContentLoading} = context!

    useEffect(() => {
        getProductNotifications().then()
    }, [])
    useEffect(() => {
        setTimeout(() => setErrorMessage(""), 5000)
    }, [errorMessage])

    const getProductNotifications = async () => {
        setTableIsLoading(true)
        getAllProductNotifications().then(productNotification => {
            setContentLoading(false)
            setTableIsLoading(false)
            setProductNotifications(productNotification.message)
        })
    }

    const renderDeleteIcon = () => productFilter ?
        <XLg onClick={() => setProductFilter("")} className="delete-icon"/> : null

    const filteredNotification = productNotifications.filter((data: ProductNotification) => {

        return data.productName.toLowerCase().includes(productFilter.toLowerCase())
    })
    const handleProductSearchChange = (event: { target: { value: SetStateAction<string> } }) => {
        setProductFilter(event.target.value)
    }

    const deleteProductNotification = () => {
        if (productNotificationsToDelete) {
            deleteProductNotifications(productNotificationsToDelete.id).then((response) => {
                setContentLoading(false)
                setShowModal(false)
                const productName = productNotificationsToDelete.productName
                setProductNotificationsToDelete(undefined)
                if (response.message) {
                    toast(`${productName} erfolgreich gelöscht.`)
                    getProductNotifications().then()
                } else {
                    toast('Produkt konnte nicht gelöscht werden.')
                }
            })
        }
    }

    const handleAddProductNotifications = (event: SyntheticEvent) => {

        event.preventDefault();
        if (!addProductNameRef.current?.value || addProductNameRef.current?.value.length < 2) {
            setErrorMessage("Bitte fülle alle Felder aus!")
            return
        }

        addProductNotifications(addProductNameRef.current?.value).then((resp) => {
            console.log(resp)
            if (resp.message.id === -1) {
                toast("Etwas ist schief gelaufen. Produkt konnte nicht hinzugefügt werden.")
            } else {
                const newItem: ProductNotification = {
                    id: resp.message.id,
                    apiKeyID: -1,
                    createdAt: new Date(),
                    productName: addProductNameRef.current!.value,
                    activeNotification: true
                }
                setProductNotifications(prev => [...prev, newItem])
                toast(`${addProductNameRef.current?.value} erfolgreich hinzugefügt.`)
                setShowAddProductModal(false)
            }
        })

    }
    const addContainer = () => {
        return <>
            <div className="modal-container overflow-hiddenf">
                <img src={product} alt=""
                     className={"img-fluid p-3 rounded-circle"} style={{maxWidth: "130px"}}/>
                <h2 className={"mb-2"} style={{color: '#3C3C3C'}}>Produkt hinzufügen</h2>
                <form className={"mt-5"} onSubmit={handleAddProductNotifications}>
                    <div className={"position-relative"}>
                        <label htmlFor="name">Produktname</label>
                        <input required type="text" id="productName" placeholder={"Produkt"} autoComplete="off"
                               ref={addProductNameRef}/>
                    </div>
                    <div className="errorMessage">
                        {errorMessage}
                        <br/>
                        {errorMessage && (<ExclamationDiamond color={"#DB2742"} size={".8em"}/>)}
                    </div>
                    <button className={"modal-container-button"} type={"submit"}>Speichern</button>
                </form>
            </div>
        </>
    }
    const deleteContainer = () => {

        return <>
            <div className="container text-center position-relative">
                <div className="row d-flex justify-content-center mb-5">
                    <img src={product} alt=""
                         className={"img-fluid p-3 rounded-circle"} style={{maxWidth: "130px"}}/>
                    <p className={"fs-5 fw-bolder"} style={{color: '#3C3C3C'}}>Produkt wirklich löschen?</p>
                    <h6 className={''} style={{color: '#3C3C3C'}}>{productNotificationsToDelete?.productName}</h6>
                </div>
                <div className="position-absolute bottom-0 start-50 translate-middle-x">
                    <div className="row">
                        <button className={"modal-container-button"} onClick={() => {
                            deleteProductNotification()
                        }}>Ja
                        </button>
                        <button className={"delete-button"} onClick={() => setShowModal(false)}>Nein</button>
                    </div>
                </div>
            </div>
        </>
    }

    return (
        <>
            <HeadNavigation path={[{path: "/", pathName: "Startseite"}, {path: null, pathName: "Angebote"}]}/>
            <Modal showModal={showModal} setShowModal={setShowModal} content={deleteContainer()}/>
            <Modal showModal={showAddProductModal} setShowModal={setShowAddProductModal} content={addContainer()}/>
            <div className="grid-padding">
                <div className="site-header d-flex justify-content-between align-items-center pb-1">
                    <h1>Produkte <span>[{productNotifications.length}]</span></h1>
                    <CButton content={"Produkt hinzufügen"} icon={<ArrowRight/>} onClick={() => {
                        setShowAddProductModal(true)
                    }}/>
                </div>
                <div className="search-input">
                    <Search className="search-icon"/>
                    <input value={productFilter} placeholder={"Suche nach Produkt"} className="employee-search"
                           type="text"
                           onChange={handleProductSearchChange}/>
                    {renderDeleteIcon()}
                </div>
                <div style={{height: 'calc(80vh - 50px)', overflowY: 'auto', overflowX: 'hidden'}}>
                    <table className={"mt-2"}>
                        <thead>
                        <tr>
                            <th>Produkt</th>
                            <th>Aktiv</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableIsLoading ? (
                            <>
                                <tr>
                                    <td colSpan={2} style={{padding: "10% 0 0 0", textAlign: "center"}}>
                                        Lade Daten...
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{padding: 0, textAlign: "center"}}>
                                        <BarLoader
                                            color={'black'}
                                            height={2}
                                            width={"20%"}
                                            cssOverride={{
                                                display: "block",
                                                margin: "0 auto",
                                                backgroundColor: "transparent",
                                                borderColor: "red",
                                                color: "red"
                                            }}
                                            speedMultiplier={.8}
                                        />
                                    </td>
                                </tr>
                            </>
                        ) : (
                            filteredNotification.length > 0 ? filteredNotification.map((item: ProductNotification) => {
                                    return (<TableRow key={item.id} item={item}
                                                      getProductNotifications={getProductNotifications}
                                                      setShowModal={setShowModal}
                                                      setProductNotificationsToDelete={setProductNotificationsToDelete}/>)
                                }) :
                                <>
                                    <tr>
                                        <td colSpan={4} style={{padding: "10% 0 0 0", textAlign: "center"}}>
                                            <BalloonHeartFill size={"100px"} color={"#aaa"}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="empty-employee-list-msg">
                                            Es sind noch keine Produkte hinterlegt.
                                        </td>
                                    </tr>
                                </>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}